export const DATE_SHIFTS: Record<string, number> = {
  UTC: 0,
  GMT: 0,
  CET: 60,
  EET: 120,
  PST: -480,
  MST: -420,
  CST: -360,
  EST: -300,
  IST: 330,
}
